export default __webpack_public_path__ + "static/media/ss-date-night.e93a54b7.png";